export class CategoriaIncompativelMessageStrategy {
	constructor(categoriaAnterior, categoriaAtual) {
		this.categoriaAnterior = categoriaAnterior
		this.categoriaAtual = categoriaAtual
	}

	get short() {
		return { message: 'Categoria foi alterada' }
	}

	get long() {
		const message = `A categoria da árvore do inventário anterior era ${this.categoriaAnterior} e foi alterada para ${this.categoriaAtual}`
		const title = 'A categoria da árvore foi alterada'
		return { message, title }
	}
}
